<template>
  <div class="">

    <el-form ref="cnvs_dufi" label-width="140px" label-position="right" size="mini">

      <el-row :gutter="10" class="bg_gray">
        <el-col :span="5">
          <el-row class="bg_gray">

            <el-col>
              <el-form-item label="Bins">
                <el-input-number placeholder="" controls-position="right" v-model="dufi_sc_bins" size="small" :step="1" :min="0" style="width: 80%"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="Quality">
                <el-input-number placeholder="" controls-position="right" v-model="dufi_sc_bf" size="small" :step="0.1" :min="0.0" style="width: 80%"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="Reads Expected">
                <el-input-number placeholder="" controls-position="right" v-model="dufi_sc_reads_exp" size="small" :step="1" :min="0" style="width: 80%"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="Reads Observed">
                <el-input-number placeholder="" controls-position="right" v-model="dufi_sc_reads_obs" size="small" :step="1" :min="0" style="width: 80%"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="Reads Ratio">
                <el-input-number placeholder="" controls-position="right" v-model="dufi_sc_reads_rat" size="small" :step="0.01" :min="0.0" style="width: 80%"></el-input-number>
              </el-form-item>
            </el-col>

          </el-row>
        </el-col>

        <el-col :span="7">
          <el-row class="bg_gray">

            <el-col>
              <el-form-item label="ID CNV">
                <el-input placeholder="" v-model="dufi_id_cnv" style="width: 90%" clearable>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="Length">
                <el-input placeholder="" v-model="dufi_sv_length" style="width: 90%" clearable>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="Type">
                <el-select class=""
                  size="small"
                  multiple
                  placeholder=""
                  v-model="dufi_deldups"
                  :disabled="rapp === 'fastras'"
                  style="width: 90%"
                  >
                  <el-option v-for="one in l_deldups"
                    :value="one.id_deldup"
                    :label="one.deldup"
                    :key="one.id_deldup"
                    >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="ACMG">
                <el-select class=""
                  size="small"
                  multiple
                  placeholder=""
                  v-model="dufi_acmg_sigs"
                  :disabled="rapp === 'fastras'"
                  style="width: 90%"
                  >
                  <el-option v-for="one in d_acmg_sigs"
                    :value="one.mynum"
                    :label="one.mytext"
                    :key="one.mynum"
                    >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="Chromosome">
                <el-select class=""
                  size="small"
                  multiple
                  placeholder=""
                  v-model="dufi_chroms"
                  :disabled="rapp === 'fastras'"
                  style="width: 90%"
                  >
                  <el-option v-for="one of l_chroms"
                            :value="one.id_chrom"
                            :label="one.chrom"
                            :key="one.id_chrom">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
        </el-col>

        <el-col :span="12">

          <el-row class="bg_gray">

            <el-col :span="22" :offset="1">
              <el-form-item label="Int. classes A">
                <el-select class=""
                  style="width: 100%"
                  size="small"
                  multiple
                  placeholder=""
                  v-model="dufi_iclasses_a"
                  :disabled="rapp === 'fastras'"
                  >
                  <el-option v-for="one of l_iclasses"
                            :value="one.id_iclass"
                            :label="one.iclass"
                            :key="one.id_iclass">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="22" :offset="1">
              <el-form-item label="Int. classes B">
                <el-select class=""
                  style="width: 100%"
                  size="small"
                  multiple
                  placeholder=""
                  v-model="dufi_iclasses_b"
                  :disabled="rapp === 'fastras'"
                  >
                  <el-option v-for="one of l_iclasses"
                            :value="one.id_iclass"
                            :label="one.iclass"
                            :key="one.id_iclass">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="22" :offset="1">
              <el-form-item label="Pseudopanels">
                <el-select class=""
                  style="width: 100%"
                  size="small"
                  multiple
                  @change="pseudopanels_change"
                  placeholder=""
                  v-model="dufi_pseudopanels"
                  :disabled="rapp === 'fastras'"
                  >
                  <el-option v-for="one in Object.keys(d_pseudopanels)"
                    :value="one"
                    :label="one"
                    :key="one"
                    >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="22" :offset="1">
              <el-form-item label="HPO">
                <el-button class="button_icon blue" plain @click="click_modal_hpo_terms()" size="small">Show HPO TERMS</el-button>
              </el-form-item>
            </el-col>

            <el-col :span="22" :offset="1">
              <el-form-item label="Genes">
                <el-button class="button_icon blue" plain @click="click_modal_genes()" size="small">Show {{ dufi_genes.length }} genes</el-button>
                <el-button class="button_icon orange" plain @click="dufi_genes_del()" size="small">Delete all genes</el-button>
              </el-form-item>
            </el-col>

          </el-row>
        </el-col>

        <el-col :span="24">
          <el-divider />

          <el-row :gutter="10">
            <el-col :span="1" :offset="1">
              <label class="col-form-label top_margin_3 and_label">Filter</label>
            </el-col>
            <el-col :span="8" class="mb-15">
              <el-select
                v-model="dufi_selected"
                placeholder=""
                filterable
                style="width: 90%"
                @change="change_dufi"
              >
                <el-option
                  v-for="item in l_dufis"
                  :key="item.id_dufi"
                  :label="item.dufi_name"
                  :value="item.id_dufi"
                />
              </el-select>
            </el-col>
            <el-col :span="14">
              <el-button-group class="ml-30">
                <el-button type="success" style="width: 130px" class="button_icon sun" :disabled="dufi_selected < 2" @click="dufi_save">Save</el-button>
                <el-button type="success" plain style="width: 130px" class="button_icon sun" @click="dufi_save_as">Save as</el-button>
                <el-button type="info" disabled style="width: 10px"> &nbsp; </el-button>
                <el-button type="warning" style="width: 130px" class="button_icon sun" @click="dufi_clean">Clean</el-button>
                <el-button :disabled="dufi_selected < 2" type="danger" style="width: 130px" class="button_icon sun" @click="dufi_delete">Delete</el-button>
                <el-button type="info" disabled style="width: 10px"> &nbsp; </el-button>
                <el-button type="info" style="width: 130px" class="button_icon sun ml-30" @click="show_cnv">Show CNV</el-button>
              </el-button-group>
            </el-col>
          </el-row>

        </el-col>

      </el-row>

    </el-form>


    <el-dialog :visible.sync="modal_genes" title="Genes in current filter" class="my_dialog_1" width="1000px" center draggable @close="close_modal_genes()" :close-on-click-modal="false">
      <el-row>
        <el-col :span="24">
          <h1 class="white-set-mod"></h1>
        </el-col>
      </el-row>
      <div class="modal_col_bg_1">
        <el-row :gutter="10" justify="space-between">
          <el-col :span="10" class="mb-15">
            <el-input
              v-model="genes_search"
              size=""
              class="top_margin_10"
              placeholder="Type to search Gene" />
          </el-col>
          <el-col :span="10" :offset="4" class="mb-15">
            <el-select
              v-model="genes_add"
              style="width: 85%"
              filterable
              clearable
              placeholder="Type 2 min. chars ... to add Gene"
              remote
              :remote-method="remoteGene"
              :loading="remote_gene_loading"
              >
              <el-option
                v-for="one in ac_genes"
                :key="one.id_gene"
                :label="one.gene_symbol"
                :value="one.id_gene"
                >
              </el-option>
            </el-select>
            <el-button type="success" :disabled="genes_add.length < 2 "  @click="click_genes_add" link class="button_icon action" icon="icofont-ui-add"><el-icon :size="20"><Delete /></el-icon></el-button>

          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-table
              :data="genes_data.filter(one => one.gene_symbol.includes(genes_search)).slice((pagination_dufi_genes.currentPage -1) * pagination_dufi_genes.perPage, (pagination_dufi_genes.currentPage) * pagination_dufi_genes.perPage)"
              style="width: 100%"
              highlight-current-row
              :max-height="600"
              >
            <el-table-column label="NCBI Gene ID" width="200">
              <template #default="scope">
                <a
                  v-if="scope.row && scope.row.id_gene"
                  :href="mylink_ncbi_gene_id(scope.row.id_gene)"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="my_link"
                >
                  {{ scope.row.id_gene }}
                </a>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column label="Symbol" min-width="200">
              <template #default="scope">
                <a
                  v-if="scope.row && scope.row.gene_symbol"
                  :href="mylink_genecards_symbol(scope.row.gene_symbol)"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="my_link"
                >
                  {{ scope.row.gene_symbol }}
                </a>
                <span v-else>-</span>
              </template>
            </el-table-column>
              <el-table-column
                prop=""
                label=""
                min-width="200"
                >
              </el-table-column>
              <el-table-column
                width="150"
                fixed="right"
                label="Actions"
                align="center"
                class-name="custom-cell"
                label-class-name="custom-cell"
                >
                <template #default="scope">
                  <el-button-group>
                    <el-button type="danger" @click="dufi_gene_delete( scope.row, $event )" size="small" link class="button_icon action" icon="icofont-trash"><el-icon :size="20"><Delete /></el-icon></el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="12" :offset="12">
            <el-pagination
              class="pull-right pagination_mezera"
              :current-page.sync="pagination_dufi_genes.currentPage"
              :page-sizes="pagination_dufi_genes.perPageOptions"
              :page-size="pagination_dufi_genes.perPage"
              layout="total, sizes, prev, pager, next, jumper"
              :total="genes_data.filter(one => one.gene_symbol.includes(genes_search)).length"
              background
              @size-change="sizeChangePage_dufi_genes"
              >
            </el-pagination>
          </el-col>

        </el-row>

      </div>

      <el-row justify="center">
        <el-col :span="24" class="flex-center col-150">

        </el-col>
      </el-row>
    </el-dialog>


    <el-dialog :visible.sync="modal_hpo_terms" title="HPO terms" class="my_dialog_1" width="1000px" center draggable @close="close_modal_hpo_terms()" :close-on-click-modal="false">
      <el-row>
        <el-col :span="24">
          <h1 class="white-set-mod"></h1>
        </el-col>
      </el-row>
      <div class="modal_col_bg_1">
        <el-row :gutter="10" justify="space-between">
          <el-col :span="12" class="mb-15">
            <el-input
              v-model="pagination_hpo_terms.search"
              size=""
              class="top_margin_10"
              placeholder="Type to search HPO"
              clearable
              @keyup.enter.native="a_hpos_get()"
              @clear="a_hpos_get()"
              />
          </el-col>
          <el-col :span="2" class="mb-15">
            <el-button type="primary" @click="a_hpos_get()">
              <i class="icofont-search"></i>
            </el-button>
          </el-col>
          <el-col :span="10" class="mb-15 text-right">
            <div class="vertical-separator"></div>

          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-table
              :data="l_hpos"
              style="width: 100%"
              highlight-current-row
              :max-height="600"
              v-loading="loading_hpos"
              element-loading-text="Loading..."
              element-loading-spinner="icofont-refresh icofont-5x"
              element-loading-background="rgba(100, 100, 100, 0.5)"
              >
              <el-table-column
                prop="hpo_term_my"
                label="HPO term name"
                min-width="600"
                >
              </el-table-column>
              <el-table-column
                prop="count_genes"
                label="Genes"
                min-width="100"
                align="center"
                >
              </el-table-column>
              <el-table-column
                width="150"
                fixed="right"
                label="Actions"
                align="center"
                class-name="custom-cell"
                label-class-name="custom-cell"
                >
                <template #default="scope">
                  <el-button-group>
                    <el-button type="success" @click="hpo_term_genes_add( scope.row, $event )" size="small" link class="button_icon action" icon="icofont-square-right"><el-icon :size="20"></el-icon></el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="12" :offset="12">
            <el-pagination
              class="pull-right pagination_mezera"
              :current-page.sync="pagination_hpo_terms.currentPage"
              :page-sizes="pagination_hpo_terms.perPageOptions"
              :page-size="pagination_hpo_terms.perPage"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination_hpo_terms.total"
              background
              @size-change="sizeChangePage_hpo_terms"
              @current-change="currentChangePage_hpo_terms"
              >
            </el-pagination>
          </el-col>

        </el-row>

      </div>

      <el-row justify="center">
        <el-col :span="24" class="flex-center col-150">

        </el-col>
      </el-row>
    </el-dialog>

 </div>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  export default {
    name: 'cnvs_dufi',
    props: {
    },
    components: {
    },


    data () {
      return {
        show: true,
        show_genes: true,

        genes_add: "",

        selects: {
          simple: '',
          multiple: 'ARS'
        },


        my_pseudopanels: [],

        s_search: '',
        searchQuery_v: '',
        propsToSearch_v: [],
        // AC_genes_loading: false,

      }
    },

    computed: {
      ...mapState({
        vars: state => state.vars,
        l_gene: state => state.l_gene,
        l_consequences: state => state.l_consequences,
        l_features: state => state.l_features,
        l_iclasses: state => state.l_iclasses,
        d_a_cols: state => state.d_a_cols,
        d_acmg_sigs: state => state.d_acmg_sigs,

        d_pseudopanels: state => state.d_pseudopanels,
        d_acmgs: state => state.d_acmgs,
        l_chroms: state => state.l_chroms,
        l_deldups: state => state.l_deldups,
        l_hpos: state => state.l_hpos,
        l_dufis: state => state.l_dufis,

        dufi: state => state.dufi,
        cnvs_selected: state => state.cnvs_selected,
        loading_hpos: state => state.loading_hpos,

        // dufi_genes_data: state => state.dufi_genes_data,
        pagination_dufi_genes: state => state.pagination_dufi_genes,
        pagination_hpo_terms: state => state.pagination_hpo_terms,

        remote_gene_loading: state => state.remote_gene_loading,
        ac_genes: state => state.ac_genes,

        id_project: state => state.id_project,
        id_examination: state => state.id_examination,
        id_workflow: state => state.id_workflow,
        selected_exams: state => state.selected_exams,

        user_setup: state => state.user_setup,

        token: state => state.token,
        user: state => state.user,
        subject: state => state.subject,
        application: state => state.application,
        app: state => state.app,
        rapp: state => state.rapp,

      }),

      ...mapGetters({
        g_gene: 'g_gene',
        g_examination: 'g_examination',
        g_examination_export: 'g_examination_export',
        g_project: 'g_project',
        g_iclasses: 'g_iclasses',
        g_cufis: 'g_cufis',

        }),


      dufi_sc_bins: {
        get () { return this.$store.state.dufi.sc_bins; },
        set (value) { let mykey = "sc_bins"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_sc_bf: {
        get () { return this.$store.state.dufi.sc_bf; },
        set (value) { let mykey = "sc_bf"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_sc_reads_exp: {
        get () { return this.$store.state.dufi.sc_reads_exp; },
        set (value) { let mykey = "sc_reads_exp"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_sc_reads_obs: {
        get () { return this.$store.state.dufi.sc_reads_obs; },
        set (value) { let mykey = "sc_reads_obs"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_sc_reads_rat: {
        get () { return this.$store.state.dufi.sc_reads_rat; },
        set (value) { let mykey = "sc_reads_rat"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_deldups: {
        get () { return this.$store.state.dufi.deldups; },
        set (value) { let mykey = "deldups"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_sv_length: {
        get () { return this.$store.state.dufi.sv_length; },
        set (value) { let mykey = "sv_length"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_id_cnv: {
        get () { return this.$store.state.dufi.id_cnv; },
        set (value) { let mykey = "id_cnv"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_iclasses_a: {
        get () { return this.$store.state.dufi.iclasses_a; },
        set (value) { let mykey = "iclasses_a"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_iclasses_b: {
        get () { return this.$store.state.dufi.iclasses_b; },
        set (value) { let mykey = "iclasses_b"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_acmg_sigs: {
        get () { return this.$store.state.dufi.acmg_sigs; },
        set (value) { let mykey = "acmg_sigs"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_chroms: {
        get () { return this.$store.state.dufi.chroms; },
        set (value) { let mykey = "chroms"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_genes: {
        get () { return this.$store.state.dufi.genes; },
        set (value) { let mykey = "genes"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_pseudopanels: {
        get () { return this.$store.state.dufi.pseudopanels; },
        set (value) { let mykey = "pseudopanels"; this.$store.commit('m_dufi', {mykey, value}); }
      },

      dufi_selected: {
        get () { return this.$store.state.dufi_selected; },
        set (value) { this.$store.commit('m_dufi_selected', value); }
      },


      modal_genes: {
        get () { return this.$store.state.modal_dufi_genes; },
        set (value) { this.$store.commit('m_modal_dufi_genes', value); }
      },


      genes_search: {
        get () { return this.$store.state.dufi_genes_search; },
        set (value) { this.$store.commit('m_dufi_genes_search', value); }
      },


      genes_data: {
        get () { return this.$store.state.dufi_genes_data; },
        set (value) { this.$store.commit('m_dufi_genes_data', value); }
      },


      modal_hpo_terms: {
        get () { return this.$store.state.modal_dufi_hpo_terms; },
        set (value) { this.$store.commit('m_modal_dufi_hpo_terms', value); }
      },


    },


    methods: {
      ...mapMutations({
        m_ss_gene: 'm_ss_gene',
        m_id_examination: 'm_id_examination',
        m_modal_pseudopanels: 'm_modal_pseudopanels',
        m_dufi_selected: 'm_dufi_selected',
        m_dufi_load: 'm_dufi_load',
        m_d_cufis: 'm_d_cufis',
        m_l_cufis: 'm_l_cufis',
        m_l_hpos: 'm_l_hpos',

      }),


      ...mapActions({
        a_varsall: 'a_varsall',
        a_vars: 'a_vars',
        a_notify: 'a_notify',
        a_hpo_get: 'a_hpo_get',
        a_cnvs: 'a_cnvs',
        a_genes_patch: 'a_genes_patch',
        a_hpos_get: 'a_hpos_get',
        a_dufis_get: 'a_dufis_get',
        a_dufi_delete: 'a_dufi_delete',
        a_ac_genes: 'a_ac_genes',
      }),


      show_cnv(){
        this.a_cnvs( { "selected": this.cnvs_selected } );
      },


      select_filter_gene(value){
        this.m_ss_gene(value);
      },


      select_filter(value){
        console.log(value);
      },

      // select_impact(value){
      //   console.log(value);
      //   this.m_cufi_impacts(value);
      // },


      dufi_clean() {
        this.dufi_sc_bins = 1;
        this.dufi_sc_bf = 1.0;
        this.dufi_sc_reads_exp = 1;
        this.dufi_sc_reads_obs = 1;
        this.dufi_sc_reads_rat = 0.01;
        this.dufi_deldups = [];
        this.dufi_sv_length = null;
        this.dufi_acmg_sigs = [];
        this.dufi_chroms = [];
        this.dufi_genes = [];
        this.dufi_iclasses_a = [];
        this.dufi_iclasses_b = [];
        this.dufi_pseudopanels = [];

        this.dufi_selected = 1;
        this.m_dufi_load(1);

        this.show_cnv();

        this.$notify({
          title: 'INFO',
          message: 'The filter has been cleared.',
          type: 'primary',
          position: 'top-right',
        });
      },


      dufi_delete() {
        if (this.dufi_selected > 1) {
          this.a_dufi_delete( { "id_dufi": this.dufi_selected })
        }

        this.dufi_selected = 1;
        this.m_dufi_load(1);

        this.show_cnv();

        this.$notify({
          title: 'INFO',
          message: 'The filter has been deleted.',
          type: 'warning',
          position: 'top-right',
        });


      },


      dufi_genes_del() {
        this.dufi_genes = [];
        this.dufi_pseudopanels = [];
        this.show_cnv();
      },


      pseudopanels_change (val) {
        let newarray = [];
        for (let one of val) {
          newarray.push(...this.d_pseudopanels[one]);
        }
        newarray.push(...this.dufi_genes);
        let sorted_genes = [...new Set(newarray)].sort()
        this.dufi_genes = sorted_genes;

        this.$notify({
          title: 'INFO',
          message: 'Genes for pseudopanel were added to the filter',
          type: 'success',
          position: 'top-right',
        });
      },


      dufi_gene_delete(row, event) {
        this.dufi_genes = this.dufi_genes.filter(x => x !== row.id_gene);
        this.a_genes_patch( {"w": "dufi", "genes": this.dufi_genes} );
        this.dufi_pseudopanels = [];
      },


      sizeChangePage_dufi_genes(val) {
        this.pagination_dufi_genes.currentPage = 1;
        this.pagination_dufi_genes.perPage = val;
      },


      change_dufi(val) {
        this.m_dufi_load(val);
        this.a_cnvs( { "selected": this.cnvs_selected } );
      },


      dufi_save() {
        axios.post(process.env.VUE_APP_BE + '/dufi', {"dufi": this.dufi}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.a_dufis_get();
            this.$notify({
              title: 'INFO',
              message: 'Filter was saved',
              type: 'success',
              position: 'top-right',
            });
          }, error => {
            console.log(error);
          });
      },


      dufi_save_as() {
        this.$prompt('Please input name', 'NEW FILTER', {
          confirmButtonText: 'CREATE NEW FILTER',
          cancelButtonText: 'Cancel',
        }).then(({ value }) => {
          this.dufi.id_dufi = null;
          this.dufi.dufi_name = value;

          axios.post(process.env.VUE_APP_BE + '/dufi', {"dufi": this.dufi}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
            .then(response => {
              this.a_dufis_get();
              this.$alert('New filter is ready.', 'NEW FILTER', {
                confirmButtonText: 'OK',
                callback: action => {
                  if (response.data["dufi_insert"] > 0) {
                    this.dufi_selected = response.data["dufi_insert"];
                    this.dufi.id_dufi = response.data["dufi_insert"];

                  }
                }
              });
            }, error => {
              console.log(error);
            });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Input canceled'
          });
        });

      },


      alertuj(mytext) {
        if (mytext === 1) {
          alert(mytext + " - Benign");
        } else if (mytext === 2) {
          alert(mytext + " - Likely benign");
        } else if (mytext === 3) {
          alert(mytext + " - Uncertain significance");
        } else if (mytext === 4) {
          alert(mytext + " - Likely pathogenic");
        } else if (mytext === 5) {
          alert(mytext + " - Pathogenic");
        } else {
          alert(mytext);
        }
      },


      // AC_genes(query) {
      //   if ( query.length > 1 ) {
      //     this.AC_genes_loading = true;

      //     axios.get(process.env.VUE_APP_BE + '/ac', { withCredentials: true, params: {'ac_type': 'l_gene', 'ac_data': query}, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
      //       .then(response => {
      //         this.$store.commit('m_l_gene', response.data["l_gene"]);
      //         this.AC_genes_loading = false;
      //       }, error => {
      //         console.log(error);
      //       });
      //   } else {

      //   }
      // },


      remoteGene(query) {
        if ( (query.length > 1) ) {
          this.a_ac_genes( {"ac_type": "genes", "ac_data": query} );
        } else {

        }
      },


      click_modal_genes() {
        this.a_genes_patch( {"w": "dufi", "genes": this.dufi_genes} );
        this.modal_genes = true;
      },


      close_modal_genes() {
        this.modal_genes = false;
      },


      click_modal_hpo_terms() {
        this.m_l_hpos([]);
        this.pagination_hpo_terms.search = "";
        this.a_hpos_get();
        this.modal_hpo_terms = true;
      },


      close_modal_hpo_terms() {
        this.modal_hpo_terms = false;
      },


      currentChangePage_hpo_terms(val) {
        this.pagination_hpo_terms.currentPage = val;
        this.a_hpos_get();
      },


      sizeChangePage_hpo_terms(val) {
        this.pagination_hpo_terms.currentPage = 1;
        this.pagination_hpo_terms.perPage = val;
        this.a_hpos_get();
      },


      hpo_term_genes_add(row, event) {
        event.stopImmediatePropagation();
        let newarray = [];
        newarray.push(...row.id_genes);
        newarray.push(...this.dufi_genes);
        let sorted_genes = [...new Set(newarray)].sort()
        this.dufi_genes = sorted_genes;

        this.$notify({
          title: 'INFO',
          message: 'Genes for HPO Term were added to the filter',
          type: 'success',
          position: 'top-right',
        });
      },


      click_genes_add() {
        let newarray = [];
        newarray.push(this.genes_add);
        newarray.push(...this.dufi_genes);
        let sorted_genes = [...new Set(newarray)].sort()
        this.dufi_genes = sorted_genes;
        this.a_genes_patch( {"w": "dufi", "genes": this.dufi_genes} );
      },


      watch_id_examination (newid, oldid) {
        if (newid !== oldid) {
          if (this.igv_switch) {
            this.m_igv_switch(false);
          }
        }
      },


      // watch_cufi_genes (newid, oldid) {
      //   if (newid && newid.length > 0) {
      //     console.log(newid.length);
      //   }
      // },


      // watch_app (newval, oldval) {
      //   if (newval !== oldval) {
      //   }
      // },

      mylink_ncbi_gene_id(id_gene) {
        const id = (id_gene === null || id_gene === undefined) ? "" : String(id_gene).trim();
        if (!id) return "";
        return `https://www.ncbi.nlm.nih.gov/gene/${encodeURIComponent(id)}`;
      },

      mylink_genecards_symbol(symbol) {
        const s = (symbol === null || symbol === undefined) ? "" : String(symbol).trim();
        if (!s) return "";
        return `https://www.genecards.org/cgi-bin/carddisp.pl?gene=${encodeURIComponent(s)}`;
      },


    },

    beforeMount () {

      // dufi_setup() {
      //   axios.get(process.env.VUE_APP_BE + '/cnv', { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
      //     .then(response => {
      //       this.m_d_cufis( response.data["d_cufis"] );
      //       this.m_l_cufis( response.data["l_cufis"] );


      //     }, error => {
      //       console.log(error);
      //     });
      // },


    },


    created () {

    },


    mounted () {
      // if (this.rapp === 'fastras') {
      //   this.m_cufi_fastras();
      // } else {
      //   this.m_cufi_default();
      // }
    },


    afterDestroy () {

    },


    watch: {
      id_examination: {
        handler: 'watch_id_examination',
        immediate: true
      },

      // cufi_genes: {
      //   handler: 'watch_cufi_genes',
      //   immediate: true
      // },

      // app: {
      //   handler: 'watch_app',
      //   immediate: true
      // },

    },


  }
</script>

<style scoped lang="scss">
  body {
    margin: 0;
  }

  .btn {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }

  .hranaty {
    border-radius: 2px !important;
  }

  .dolu {
    padding-top: 80px !important;
  }

  .mezera {
    margin-right: 10px !important;
  }

  .bottom_margin_30 {
    margin-bottom: 30px;
  }

  .bottom_margin_3 {
    margin-bottom: 3px;
  }

  .top_margin_3 {
    margin-top: 3px;
  }

  .top_margin_30 {
    margin-top: 30px;
  }

  .top_margin_50 {
    margin-top: 50px;
  }

  .bg_gray {
    background: #b7b9bb !important;
  }

  .bg_white {
    background-color: #FFF !important;
  }

  .gene_blue {
    background-color: #ccfdf3 !important;
    margin-left: 0px !important;
    border-radius: 6px !important;
  }

  .el-tag {
      border-radius: 2px !important;
      margin-left: 3px !important;
      margin-bottom: 3px !important;
  }

  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    color:#FFF !important;
    background-color:#0e1a25 !important;
    border-color:#070e14 !important;
    -webkit-box-shadow:-1px 0 0 0 #8cc5ff !important;
    box-shadow:-1px 0 0 0 #8cc5ff !important;
  }

  .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
    border-left-color:#0c151f !important;
  }

  .bg_white_tab {
    background-color: #FFF !important;
    z-index: 9999 !important;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg_blue {
    background-color: #ccfdf3 !important;
  }

  .bg-purple-light {
    background: #eee;
    min-height: 12px;
    padding-left: 4px !important;
  }

  .row-bg {
    padding: 3px 0;
    background-color: #f9fafc;
  }

  .min_height {
    border-radius: 4px;
    height: 30px !important;
  }

  .popover_bg {
    background: #a3bbf1;
  }

  .caret-wrapper {
    display: block !important;

  }


  .el-form-item {
    margin-bottom: 3px;
  }


  .el-row {
    margin-top: 10px;
    &:last-child {
      margin-bottom: 5px;
    }
  }


  .my_link {
    color: #0b4aa2 !important;
    text-decoration: underline !important;
    cursor: pointer;
  }

  .my_link:hover {
    color: #083a7d !important;
  }


</style>
